import { cn } from "@marketing-sites/utils/cn";

export interface SectionTagsProps {
  /** Page or product name, e.g. "Fin voice 2". Renders on the left. */
  pageLabel: string;
  /** Section name, e.g. "features". Renders on the right. */
  label: string;
  className?: string;
}

export default function SectionTags({
  pageLabel,
  label,
  className,
}: SectionTagsProps) {
  // Required props still accept "", and half a pair is not a valid state, so
  // an empty label on either side omits the row rather than rendering one tag.
  if (!pageLabel.trim() || !label.trim()) return null;

  // The spacing matches the majority of hand-rolled tag pairs; callers with a
  // different rhythm override it through className.
  return (
    <div
      className={cn(
        "col-span-full flex justify-between pb-8 pt-8 md:pt-5",
        className,
      )}
    >
      <p className="text-label-lg text-current/50">{pageLabel}</p>
      <p className="text-label-lg text-current/50">{label}</p>
    </div>
  );
}
